import React, { useState } from 'react';
import '../styles/Signup.css';
import { Link, useNavigate } from 'react-router-dom';
import myLogo from '../assets/images/second.jpeg';
import useFetch from '../hooks/useFetch'; // 👈 import the custom hook

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    profession: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState('');
  const { post, loading, error } = useFetch('http://localhost:5000/api/auth/register');
 const navigate = useNavigate();
  const validate = () => {
    const { email, password, confirmPassword } = formData;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) return 'Please enter a valid email address.';
    if (password.length < 6) return 'Password must be at least 6 characters.';
    if (password !== confirmPassword) return 'Passwords do not match.';
    return '';
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validate();
    if (validationError) {
      setErrors(validationError);
      return;
    }

    const result = await post(formData);

    if (result) {
       setTimeout(() => navigate('/'), 1000); 
      console.log('Signup successful:', result);
      // redirect or reset form
    }
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        
           <h2>Construction Estimation</h2>
         <img src={myLogo} className="logoS" alt="logo" width="50" height="50" />
       
        <h2>Create an Account</h2>

        {(errors || error) && <p className="error-msg">{errors || error}</p>}
        {loading && <p>Submitting...</p>}

        <label htmlFor="name">Full Name</label>
        <input
          className="email"
          type="text"
          name="name"
          id="name"
          required
          value={formData.name}
          onChange={handleChange}
        />
<select className="profession" name='profession'  onChange={handleChange} value={formData.profession}> 
  <option value=""> -- Select Profession --</option>
  <option value="Architect"> Architect</option>
   <option value="Quantity Surveyor">Quantity Surveyor</option>
    <option value="Engineer">Enginner</option>
    <option value="Project Manager">Project Manager</option>
    <option value="Contractor">Contractor</option>
    <option value="Builder">Builder</option>
    <option value="Building Consultant">Consultant</option>
    <option value="Estate Manager">Real Estate Developer</option>
</select>


  <label htmlFor="number">Phone number</label>
        <input
          type="tel"
          name="phone"
          className="phone"
          required
          value={formData.phone}
          onChange={handleChange}
        />

        <label htmlFor="email">Email Address</label>
        <input
          type="email"
          name="email"
          className="email"
          required
          value={formData.email}
          onChange={handleChange}
        />

        <label htmlFor="password">Password</label>
        <input
          type="password"
          name="password"
          className="password"
          required
          value={formData.password}
          onChange={handleChange}
        />

        <label htmlFor="confirmPassword">Confirm Password</label>
        <input
          type="password"
          name="confirmPassword"
          className="password"
          required
          value={formData.confirmPassword}
          onChange={handleChange}
        />

        <button type="submit" className='signup-button' disabled={loading}>
          {loading ? 'Signing Up...' : 'Sign Up'}
        </button>

        <p className="login-link">
          Already have an account? <Link to="/pages/login">Sign In</Link>
        </p>
 
      </form>
    </div>
  );
};

export default Signup;
